import { useCallback, useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import type { OrderView, WoltStatusAction } from 'shared-models/browser';
import { posWoltService } from '../../../../../services/pos-wolt/pos-wolt.service';

type Params = {
  tenantId: string;
  employeeSession: string | null;
  orderId: number;
};

// One in-flight action per order; the local state patches arrive through the POS SSE deltas.
export function useWoltOrderActions({ tenantId, employeeSession, orderId }: Params) {
  const [inFlight, setInFlight] = useState<WoltStatusAction | null>(null);
  const inFlightRef = useRef(false);

  const apply = useCallback(async (action: WoltStatusAction, reason?: string): Promise<OrderView | null> => {
    if (!employeeSession || inFlightRef.current) {
      return null;
    }
    inFlightRef.current = true;
    setInFlight(action);
    try {
      return await posWoltService.applyStatus(tenantId, employeeSession, orderId, reason ? { action, reason } : { action });
    } catch (error: unknown) {
      notifications.show({
        color: 'red',
        title: 'וולט',
        message: error instanceof Error ? error.message : 'עדכון ההזמנה בוולט נכשל',
        autoClose: 4000,
      });
      return null;
    } finally {
      inFlightRef.current = false;
      setInFlight(null);
    }
  }, [employeeSession, orderId, tenantId]);

  return { inFlight, apply };
}
